module.exports = __webpack_public_path__ + "static/media/IMG_8293.bffc98ba.JPG";